var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2995 22.8843V27.2611C16.2995 27.8415 16.1248 28.3982 15.8138 28.8085C15.5028 29.2189 15.081 29.4495 14.6411 29.4495H3.0322C2.59235 29.4495 2.17053 29.2189 1.85952 28.8085C1.5485 28.3982 1.37378 27.8415 1.37378 27.2611V3.18843C1.37378 2.60801 1.5485 2.05139 1.85952 1.64097C2.17053 1.23057 2.59235 1 3.0322 1H14.6411C15.081 1 15.5028 1.23057 15.8138 1.64097C16.1248 2.05139 16.2995 2.60801 16.2995 3.18843V7.56528",
    stroke: "white",
    strokeWidth: 1.65842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9332 15.2249H9.66589",
    stroke: "white",
    strokeWidth: 1.65842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9827 10.848L9.66589 15.2249L12.9827 19.6017",
    stroke: "white",
    strokeWidth: 1.65842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.feb5d35f500f31762b49be12d3fe7f0b.svg";
export { ForwardRef as ReactComponent };